<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>
                <span *ngIf="this.selectedOrganizationName">
                    {{ this.selectedOrganizationName }}
                </span>
                Claims
            </h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button class="action-button d-flex col-auto align-items-center"
                (click)="onNewClaimClick()">
                <mat-icon>add</mat-icon>
                New Claim
            </button>
        </div>
    </div>
    <mat-card appearance="outlined" class="mt-3 pb-5">
        <div class="row justify-content-center">
            <mat-tab-group dynamicHeight [preserveContent]="true">
                <mat-tab label="Claims">
                    <div class="col-12" style="min-height:340px;">
                        <app-data-table 
                            [component]="'Claims'" 
                            (searchEvent)="onActiveClaimsSearchEvent($event)"
                            (pageEvent)="onActiveClaimsPageEvent($event)"
                            (sortEvent)="onActiveClaimsSortEvent($event)"
                            [dataSource]="activeClaimsDataSource" 
                            [displayedColumns]="tableColumns"
                            [tableLength]="activeClaimsTableLength" 
                            [pageSize]="pageSize"
                            [pageNumber]="pageNumber"
                            [showPaginator]="true"
                            [filterDefinitions]="filterDefinitions" 
                            [displayLoadingIndicator]="loading"
                            [disableSorting]="false"
                            [getStatusColor]="getPillStatusColor"
                            [initialPageSize]="this.initialPageSize"
                            [initialPageNumber]="this.initialPageNumber"
                            [initialKeyword]="this.initialKeyword"
                            [initialSort]="this.initialSort">
                        </app-data-table>
                    </div>
                </mat-tab>
                <mat-tab label="Deleted Claims">
                    <ng-template matTabContent>
                        <div class="col-12">
                            <app-deleted-claims-table
                                [component]="'deleted claims'" 
                                (searchEvent)="onDeletedClaimsSearchEvent($event)"
                                (pageEvent)="onDeletedClaimsPageEvent($event)"
                                (sortEvent)="onDeletedClaimsSortEvent($event)"
                                [dataSource]="deletedClaimsDataSource" 
                                [displayedColumns]="deleteClaimTableColumns"
                                [displayLoadingIndicator]="loading"
                                [tableLength]="deletedClaimsTableLength" 
                                [pageSize]="pageSize"
                                [showPaginator]="true"
                                [getStatusColor]="getPillStatusColor"
                                [actionButtonText]="'Undelete'"
                                (actionClickedEvent)="onUndeleteClaimActionClick($event)">
                            </app-deleted-claims-table>
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </mat-card>
</div>